import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { Button, Dialog, ExitIcon } from "@sundae/ui-toolkit";
import { useWallet, useWalletDetails } from "@sundae/wallet-react";
import { useCallback, useEffect } from "react";
import { Actions, useAppContext } from "../../../stores/index.js";
import { isWrongNetwork } from "../../../utils/network.utils.js";
const WrongNetworkDialog = () => {
    const { t } = useI18N("wallet");
    const { details } = useWalletDetails();
    const { logoutWallet } = useWallet();
    const { state: { wrongNetworkOpen }, dispatch, } = useAppContext();
    useEffect(() => {
        if (details && typeof details?.network === "undefined") {
            return;
        }
        if (isWrongNetwork(details?.network)) {
            Actions.setWrongNetworkOpen(true, dispatch);
        }
    }, [details]);
    const handleDisconnect = useCallback(async () => {
        await logoutWallet().then(() => {
            location.reload();
        });
    }, []);
    const handleClose = useCallback(() => Actions.setWrongNetworkOpen(false, dispatch), [dispatch]);
    return (_jsx(Dialog, { open: wrongNetworkOpen, closeDialog: handleClose, description: t("connectDialog.wrongNetwork", {
            network: window.__APP_CONFIG.envName,
        }), title: t("connectDialog.wrongNetwork", {
            context: "title",
        }), children: _jsxs("div", { className: "flex items-center justify-center gap-8", children: [_jsxs(Button, { variant: "primary", onClick: handleDisconnect, children: [t("dialogs.wrong_net_action"), _jsx(ExitIcon, { className: "fill-current" })] }), _jsx(Button, { variant: "neutral", onClick: handleClose, children: t("connectDialog.wrongNetwork", {
                        context: "dismiss",
                    }) })] }) }));
};
export default WrongNetworkDialog;
//# sourceMappingURL=WrongNetworkDialog.js.map